import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeEvery } from "redux-saga/effects";

import { rsf } from "../../../init/firebase";
import { DocumentSnapshot } from "../../../types/firebase.types";
import { getChatRoomMessagesAction } from "../redux/actions";
import { setChatRoomMessages, setChatRoomMessagesLoading } from "../redux/reducer/chat.reducer";
import { GetRoomMessagesActionData } from "../type/queries.types";

function* getRoomMessages(data: PayloadAction<GetRoomMessagesActionData>): any {
  const roomId = data.payload.roomId;
  const getRoomMessagesQuery = data.payload.getRoomMessagesQuery;

  try {
    yield put(setChatRoomMessagesLoading(true));
    const snapshot = yield call(rsf.firestore.getCollection, getRoomMessagesQuery());

    if (!snapshot.empty) {
      yield put(
        setChatRoomMessages({
          roomId,
          messages: snapshot.docs.map((doc: DocumentSnapshot) => ({
            ...doc.data(),
            id: doc.id,
            ref: doc.ref,
            snapshot: doc,
          })),
        })
      );
    }
  } catch (ex: any) {
    yield put(setChatRoomMessages({ roomId, messages: [] }));
    console.log(ex.message);
  } finally {
    yield put(setChatRoomMessagesLoading(false));
  }
}

export default function* watchGetRoomMessages() {
  yield takeEvery(getChatRoomMessagesAction.toString(), getRoomMessages);
}
